export class SimulationReportRoutesPaths {
  static report = 'report/:shareToken';
  static access = 'access';
  static reportOverview = 'overview';
  static confidence = 'confidence';
  static confusions = 'confusions';
  static human = 'human';
  static simulated = 'simulated';
  static participants = 'participants';
  static paths = 'paths';
  static addParticipant = 'participants/more';
  static humanParticipants = 'participants/human';
  static simulatedParticipants = 'participants/simulated';

  static goToReport(shareToken: string) {
    return `/report/${shareToken}`;
  }

  static goToReportAccess(shareToken: string) {
    return `/report/${shareToken}/access`;
  }

  static goToPlans(shareToken: string) {
    return `/report/${shareToken}/plans`;
  }

  static goToInvoices(shareToken: string) {
    return `/report/${shareToken}/invoices`;
  }

  static goToReportOverview(shareToken: string) {
    return `/report/${shareToken}/${this.reportOverview}`;
  }

  static goToConfidence(shareToken: string) {
    return `/report/${shareToken}/${this.confidence}`;
  }

  static goToConfusions(shareToken: string) {
    return `/report/${shareToken}/${this.confusions}`;
  }

  static goToHumanParticipants(shareToken: string) {
    return `/report/${shareToken}/${this.participants}/${this.human}`;
  }

  static goToSimulatedParticipants(shareToken: string) {
    return `/report/${shareToken}/${this.participants}/${this.simulated}`;
  }

  static goToSinglePath(shareToken: string, pathId: string) {
    return `/report/${shareToken}/${this.paths}/${pathId}`;
  }

  static goToSinglePathView(
    shareToken: string,
    type: 'human' | 'simulated',
    pathId: string,
    viewId: string
  ) {
    return `/report/${shareToken}/${this.paths}/${type}/${pathId}/${viewId}`;
  }
}
